import React, { useState } from "react";
import firebase from 'firebase/compat/app';
import "firebase/database"
import { getAuth } from "firebase/auth";
import { Button, Form, Container, Row } from 'react-bootstrap'
import Output from "./Output";
import FavoritedProducts from "./FavoritedProducts";
import './Scan.css';


function Scan() {

    const [scanInput, setScanInput] = useState("")
    const [scanOutput, setScanOutput] = useState(false)

    function handleSubmit(event) {
        event.preventDefault()
    }


    function findBarcodePair() {

        setScanInput("")

        const auth = getAuth();
        const user = auth.currentUser;
        const uid = user.uid;


        const newProductRef = firebase.database().ref(uid + "/newProduct")

        // ovdje ispod je način kako čitamo podatke iz naše firebase liste
        newProductRef
            .orderByChild("barcode")
            .equalTo(scanInput)
            .on("value", function (snapshot) {
                snapshot.forEach(function (data) {
                    var snapshotDataKey = data.key

                    var product = snapshot
                        .child(snapshotDataKey)
                        .val()

                    if (scanInput === product.barcode) {
                        setScanOutput(product)
                    }

                })
            })
    }

    return (
        <div>
            <Container id="code">
                <Row>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <h4>Enter the barcode and click "search" to find the custom code you are looking for</h4>
                            <Form.Control className="input-color" value={scanInput} onChange={(e) => setScanInput(e.target.value)} as="textarea" placeholder="Enter your barcode here" onFocus={(e) => e.target.placeholder = ""} onBlur={(e) => e.target.placeholder = "Enter your barcode here"} />
                        </Form.Group>
                        <Button onClick={findBarcodePair} variant="dark">Search</Button>
                    </Form>
                </Row>
            </Container>


            <Output foundProduct={scanOutput} />
            <FavoritedProducts />

        </div>
    )
}

export default Scan